import { useEffect, useState } from 'react';

const API_URL = '';

let _cache = null;
let _promise = null;
const listeners = new Set();

async function _fetch() {
  try {
    const res = await fetch(`${API_URL}/api/settings`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    _cache = await res.json();
  } catch {
    _cache = {}; // fail-open with empty settings — callers apply their own defaults
  }
  listeners.forEach((cb) => cb(_cache));
  return _cache;
}

export function getSettings() {
  return _cache;
}

export function loadSettings() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) _promise = _fetch().finally(() => { _promise = null; });
  return _promise;
}

/** React hook — returns { settings, ready } and re-renders when settings load/refresh. */
export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache);
  useEffect(() => {
    let mounted = true;
    const listener = (s) => { if (mounted) setSettings(s); };
    listeners.add(listener);
    if (_cache == null) {
      loadSettings();
    }
    return () => { mounted = false; listeners.delete(listener); };
  }, []);
  return { settings: settings || {}, ready: settings !== null };
}

/**
 * Compute shipping cost applying the admin free-shipping toggle.
 * @param baseShipping Raw shipping cost before free-shipping rule.
 * @param subtotal    Cart subtotal.
 * @param settings    Site settings object (from useSiteSettings). Optional — uses _cache.
 */
export function applyFreeShipping(baseShipping, subtotal, settings = null) {
  const s = settings || _cache || {};
  const enabled = s.free_shipping_enabled !== false; // default TRUE for safety when API unavailable
  const threshold = Number(s.free_shipping_threshold ?? 10000);
  if (enabled && Number(subtotal || 0) >= threshold) return 0;
  return Number(baseShipping || 0);
}

/** Force a refresh (useful after admin toggles a setting). */
export function refreshSettings() {
  _cache = null;
  return loadSettings();
}
